import { render, staticRenderFns } from "./ChallengeDialogNoProfile.vue?vue&type=template&id=35b76c10"
import script from "./ChallengeDialogNoProfile.vue?vue&type=script&lang=ts"
export * from "./ChallengeDialogNoProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports